import { actionTypes } from "./action_types";
import {
  get_clusters_list,
  get_area_list,
  get_crdm_pepp_hierarchy,
  get_branch_by_code,
} from "../services/crdm_service";

export const GetClusters = () => (dispatch) => {
  return get_clusters_list().then((resp) => {
    dispatch({
      type: actionTypes.CRDM_GET_CLUSTERS,
      payload: resp.data ? resp.data : [],
    });
    return Promise.resolve(resp);
  });
};

export const GetAreas = (data) => (dispatch) => {
  return get_area_list(data).then((resp) => {
    dispatch({
      type: actionTypes.CRDM_GET_AREAS,
      payload: resp.data ? resp.data : [],
    });
    return Promise.resolve(resp);
  });
};

export const GetMasterClusters = (data) => (dispatch) => {
  return get_clusters_list(data).then((resp) => {
    dispatch({
      type: actionTypes.CRDM_GET_MASTER_CLUSTERS,
      payload: resp.data ? resp.data : [],
    });
    return Promise.resolve(resp);
  });
};

export const GetMasterAreas = (data) => (dispatch) => {
  return get_area_list(data).then((resp) => {
    dispatch({
      type: actionTypes.CRDM_GET_MASTER_AREAS,
      payload: resp.data ? resp.data : [],
    });
    return Promise.resolve(resp);
  });
};

export const GetPeppHierarchy = (data) => (dispatch) => {
  return get_crdm_pepp_hierarchy(data).then((resp) => {
    dispatch({
      type: actionTypes.CRDM_GET_PEPP_HIERARCHY,
      payload: resp.data,
    });
    return Promise.resolve(resp);
  });
};

export const GetBranchByCode = (data) => (dispatch) => {
  return get_branch_by_code(data).then((resp) => {
    dispatch({
      type: actionTypes.CRDM_GET_PEPP_BRANCH,
      payload: resp.data,
    });
    return Promise.resolve(resp);
  });
};

export const SetIsSpecial = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.CRDM_SET_IS_SPECIAL,
    payload: data,
  });
};
